import React from 'react';
import { Brand } from '@printdeal/ui-library';

interface Props {
  issuerId?: string;
}

const MandateIssuerIcon = ({ issuerId }: Props) => {
  const mandateIssuerIcon = () => {
    switch (issuerId) {
      case 'ABNANL2A':
        return (
          <Brand brand="abnamro" className="pd-h-7" />
        );
      case 'INGBNL2A':
        return (
          <Brand brand="ing" className="pd-h-7" />
        );
      case 'RABONL2U':
        return (
          <Brand brand="rabobank" className="pd-h-7" />
        );
      default:
        return null;
    }
  };

  return mandateIssuerIcon();
};

export default MandateIssuerIcon;
